App.controller('LoginCtrl', LoginCtrl);

LoginCtrl.$inject = [
    '$location',
    'localStorageService',
    'DispatcherService'
];

function LoginCtrl($location, localStorageService, DispatcherService) {
    var vm = this;

    vm.email =      '';
    vm.password =   '';

    vm.submit = submit;

    function submit() {
        DispatcherService.post('login', {email: vm.email, password: vm.password}).then(function(response) {
            localStorageService.set('token', response.token);

            $location.path('/responses');
        });
    }
}